/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import dayjs from 'dayjs';

/**
 * Formate une date en JJ/MM/AAAA. Une date absente ou invalide renvoie le
 * libellé de repli : `dayjs(undefined)` vaut la date du jour, il ne faut donc
 * pas l'appeler sur une date non renseignée.
 */
const formatDate = (
  date?: string | Date | null,
  fallback = 'Non renseignée',
): string => {
  const parsed = date ? dayjs(date) : null;

  return parsed?.isValid() ? parsed.format('DD/MM/YYYY') : fallback;
};

export default formatDate;
